import { guideImage, guideItems } from "@/mocks/site";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="PITFALL GUIDE"
          title="四个节点的避坑动作"
          desc="大部分消费纠纷，都能在流程里提前留好证据。按下面四个节点走一遍，沟通成本会低很多。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="lg:col-span-5">
            <div className="relative h-64 w-full overflow-hidden rounded-lg border border-background-200 lg:sticky lg:top-28 lg:h-[520px]">
              <img
                src={guideImage}
                alt="避坑指南配图：笔记本、放大镜与清单卡片的档案桌面"
                title="消费避坑指南｜四个节点的取证动作"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-5 md:p-6">
                <p className="font-heading text-base font-bold text-background-50 md:text-lg">
                  证据留得越早，维权越省力
                </p>
                <p className="mt-1.5 text-xs leading-relaxed text-background-50/80 md:text-sm">
                  下单截图、开箱视频、沟通记录，三样东西覆盖了绝大多数售后场景。
                </p>
              </div>
            </div>
          </Reveal>

          <div className="flex flex-col gap-4 lg:col-span-7">
            {guideItems.map((step, index) => (
              <Reveal key={step.id} delay={index * 80}>
                <article className="flex gap-5 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${step.icon} text-2xl leading-none`}></i>
                  </span>
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <span className="font-heading text-sm font-bold text-primary-500">STEP 0{index + 1}</span>
                      <h3 className="font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                    <ul className="mt-3 flex flex-wrap gap-2">
                      {step.points.map((point) => (
                        <li key={point} className="flex items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-1 font-label text-xs text-foreground-700">
                          <i className="ri-checkbox-circle-line text-sm leading-none text-secondary-600"></i>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}